import Zones from './views/Zones'
import Zone  from './views/Zone'
import Cities from './views/Cities'
import City   from './views/City'
import Discounts from './views/Discounts'
import Discount  from './views/Discount'

import Price  from './views/Price'
import Prices from './views/Prices'
import PricesSettings from './views/PricesSettings'

import AdditionalServices from './views/additional_services/AdditionalServices'
import AdditionalService  from './views/additional_services/AdditionalService'
import AdditionalServicesPrices from './views/additional_services/AdditionalServicesPrices'
import AdditionalServicesPrice  from './views/additional_services/AdditionalServicesPrice'
import OtherSettings from './views/OtherSettings'

import Extrasizes from './views/extrasize/FreightExtrasizes'
import Extrasize  from './views/extrasize/FreightExtrasize'
import WayExtrasizes from './views/extrasize/WayFreightExtrasizes'
import WayExtrasize  from './views/extrasize/WayFreightExtrasize'

import ForwardingPrices from './views/ForwardingPrices'
import ForwardingPrice  from './views/ForwardingPrice'

import PaymentMethods from './views/PaymentMethods'
import PaymentMethod  from './views/PaymentMethod'

import DoomPrices from './views/DoomPrices'
import DoomPrice  from './views/DoomPrice'
import DoomPricesSettings  from './views/DoomPricesSettings'

import LuwPrice  from './views/luw/Luw'
import LuwPrices from './views/luw/Luws'
import LuwPricesSettings from './views/luw/LuwsSettings'

import AirportPrice  from './views/airport/Airport'
import AirportPrices from './views/airport/Airports'
import AirportLuwPrice  from './views/airport/AirportLuw'
import AirportLuwPrices from './views/airport/AirportLuws'
import AirportPricesSettings from './views/airport/AirportsSettings'

import ManipulatorPrice  from './views/manipulator/Manipulator'
import ManipulatorPrices from './views/manipulator/Manipulators'
import ManipulatorPricesSettings from './views/manipulator/ManipulatorsSettings'

import StoragePrice  from './views/storage/Storage'
import StoragePrices from './views/storage/Storages'
import StoragePricesSettings from './views/storage/StoragesSettings'

export default {
    routes: [
        {
            path: '/cost/prices',
            name: 'Prices',
            components: { default: Prices },
            meta: { tab: 'prices', setting_link: 'Prices', toolbars: ['Price']}
        },
        {
            path: '/cost/price/:price_id',
            name: 'Price',
            components: { default: Prices, right: Price },
            meta: { tab: 'prices', setting_link: 'Prices', toolbars: ['Price']}
        },
        {
            path: '/cost/price-settings',
            name: 'PricesSettings',
            components: { default: Prices, right: PricesSettings },
            meta: { tab: 'settings', setting_link: 'Prices', toolbars: ['Price']}
        },

        {
            path: '/cost/doom-prices',
            name: 'DoomPrices',
            components: { default: DoomPrices },
            meta: { tab: 'prices', setting_link: 'Prices', toolbars: ['DoomPrices']}
        },
        {
            path: '/cost/doom-price/:id',
            name: 'DoomPrice',
            components: { default: DoomPrices, right: DoomPrice },
            meta: { tab: 'prices', setting_link: 'Prices', toolbars: ['DoomPrices']}
        },
        {
            path: '/cost/doom-prices-settings',
            name: 'DoomPricesSettings',
            components: { default: DoomPrices, right: DoomPricesSettings },
            meta: { tab: 'settings', setting_link: 'Prices', toolbars: ['DoomPrices']}
        },


        {
            path: '/cost/forwarding-prices',
            name: 'ForwardingPrices',
            components: { default: ForwardingPrices },
            meta: { tab: 'forwardingprices', setting_link: 'Prices', toolbars: ['Forwarding']}
        },
        {
            path: '/cost/forwarding-prices/:price_id',
            name: 'ForwardingPrice',
            components: { default: ForwardingPrices, right: ForwardingPrice },
            meta: { tab: 'forwardingprices', setting_link: 'Prices', toolbars: ['Forwarding']}
        },

        {
            path: '/cost/extrasize',
            name: 'Extrasizes',
            components: { default: Extrasizes },
            meta: { tab: 'extrasizes', setting_link: 'Prices'}
        },
        {
            path: '/cost/extrasize/:setting_id',
            name: 'Extrasize',
            components: { default: Extrasizes, right: Extrasize },
            meta: { tab: 'extrasizes', setting_link: 'Prices'}
        },

        {
            path: '/cost/wayextrasize',
            name: 'WayExtrasizes',
            components: { default: WayExtrasizes },
            meta: { tab: 'wayextrasizes', setting_link: 'Prices'}
        },
        {
            path: '/cost/wayextrasize/:setting_id',
            name: 'WayExtrasize',
            components: { default: WayExtrasizes, right: WayExtrasize },
            meta: { tab: 'wayextrasizes', setting_link: 'Prices'}
        },

        {
            path: '/cost/services',
            name: 'AdditionalServices',
            components: { default: AdditionalServices },
            meta: { tab: 'services', setting_link: 'Prices', toolbars: ['Services']}
        },
        {
            path: '/cost/services/:service_id',
            name: 'AdditionalService',
            components: { default: AdditionalServices, right: AdditionalService },
            meta: { tab: 'services', setting_link: 'Prices', toolbars: ['Services']}
        },

        {
            path: '/cost/services-prices',
            name: 'AdditionalServicesPrices',
            components: { default: AdditionalServicesPrices },
            meta: { tab: 'services-prices', setting_link: 'Prices', toolbars: ['AdditionalServicesPrices']}
        },
        {
            path: '/cost/services-prices/:id',
            name: 'AdditionalServicesPrice',
            components: { default: AdditionalServicesPrices, right: AdditionalServicesPrice },
            meta: { tab: 'services-prices', setting_link: 'Prices', toolbars: ['AdditionalServicesPrices']}
        },


        {
            path: '/cost/discounts',
            name: 'Discounts',
            components: { default: Discounts },
            meta: { tab: 'discounts', setting_link: 'Prices'}
        },
        {
            path: '/cost/discounts/:discountid',
            name: 'Discount',
            components: { default: Discounts, right: Discount },
            meta: { tab: 'discounts', setting_link: 'Prices'}
        },
        {
            path: '/cost/other',
            name: 'OtherSettings',
            components: { default: OtherSettings },
            meta: { tab: 'other', setting_link: 'Prices'}
        },

        {
            path: '/cost/zones',
            name: 'Zones',
            components: { default: Zones },
            meta: { tab: 'zones', setting_link: 'Prices', toolbars: ['Zones']}
        },
        {
            path: '/cost/zones/:zoneid',
            name: 'Zone',
            components: { default: Zones, right: Zone },
            meta: { tab: 'zones', setting_link: 'Prices', toolbars: ['Zones']}
        },
        {
            path: '/cost/cities',
            name: 'Cities',
            components: { default: Cities },
            meta: { tab: 'cities', setting_link: 'Prices', toolbars: ['Cities']}
        },
        {
            path: '/cost/cities/:cityid',
            name: 'City',
            components: { default: Cities, right: City },
            meta: { tab: 'cities', setting_link: 'Prices',  toolbars: ['Cities']}
        },

        {
            path: '/cost/payment-methods',
            name: 'PaymentMethods',
            components: { default: PaymentMethods },
            meta: { tab: 'paymentmethods', setting_link: 'Prices'}
        },
        {
            path: '/cost/payment-methods/:method_id',
            name: 'PaymentMethod',
            components: { default: PaymentMethods, right: PaymentMethod },
            meta: { tab: 'paymentmethods', setting_link: 'Prices'}
        },

        {
            path: '/cost/luws',
            name: 'LuwPrices',
            components: { default: LuwPrices },
            meta: { tab: 'luwprices', setting_link: 'Prices', toolbars: ['Luw']}
        },
        {
            path: '/cost/luws/:id',
            name: 'LuwPrice',
            components: { default: LuwPrices, right: LuwPrice },
            meta: { tab: 'luwprices', setting_link: 'Prices'}
        },
        {
            path: '/cost/luws-settings',
            name: 'LuwPricesSettings',
            components: { default: LuwPrices, right: LuwPricesSettings },
            meta: { tab: 'settings', setting_link: 'Prices', toolbars: ['Price']}
        },

        {
            path: '/cost/airports',
            name: 'AirportPrices',
            components: { default: AirportPrices },
            meta: { tab: 'airportprices', setting_link: 'Prices'}
        },
        {
            path: '/cost/airports/:id',
            name: 'AirportPrice',
            components: { default: AirportPrices, right: AirportPrice },
            meta: { tab: 'airportprices', setting_link: 'Prices'}
        },
        {
            path: '/cost/airport-luws',
            name: 'AirportLuwPrices',
            components: { default: AirportLuwPrices },
            meta: { tab: 'airportluwprices', setting_link: 'Prices'}
        },
        {
            path: '/cost/airport-luws/:id',
            name: 'AirportLuwPrice',
            components: { default: AirportLuwPrices, right: AirportLuwPrice },
            meta: { tab: 'airportluwprices', setting_link: 'Prices'}
        },        
        {
            path: '/cost/airports-settings',
            name: 'AirportPricesSettings',
            components: { default: AirportPrices, right: AirportPricesSettings },
            meta: { tab: 'settings', setting_link: 'Prices'}
        },


        {
            path: '/cost/manipulators',
            name: 'ManipulatorPrices',
            components: { default: ManipulatorPrices },
            meta: { tab: 'manipulatorprices', setting_link: 'Prices', toolbars: ['Manipulators']}
        },
        {
            path: '/cost/manipulators/:id',
            name: 'ManipulatorPrice',
            components: { default: ManipulatorPrices, right: ManipulatorPrice },
            meta: { tab: 'manipulatorprices', setting_link: 'Prices'}
        },
        {
            path: '/cost/manipulators-settings',
            name: 'ManipulatorPricesSettings',
            components: { default: ManipulatorPrices, right: ManipulatorPricesSettings },
            meta: { tab: 'settings', setting_link: 'Prices', toolbars: ['Manipulators']}
        },

        {
            path: '/cost/storages',
            name: 'StoragePrices',
            components: { default: StoragePrices },
            meta: { tab: 'storageprices', setting_link: 'Prices', toolbars: ['Storages']}
        },
        {
            path: '/cost/storages/:id',
            name: 'StoragePrice',
            components: { default: StoragePrices, right: StoragePrice },
            meta: { tab: 'storageprices', setting_link: 'Prices'}
        },
        {
            path: '/cost/storages-settings',
            name: 'StoragePricesSettings',
            components: { default: StoragePrices, right: StoragePricesSettings },
            meta: { tab: 'settings', setting_link: 'Prices', toolbars: ['Storages']}
        },

    ]
}



// WEBPACK FOOTER //
// ./src/modules/cost/routes.js